import customer from './customer.config';
import loggedOut from './loggedOut.config';

export default {
  customer,
  loggedOut,
};
